//import "./css/CrochetProjects.css";
import "../css/ComingSoon.css";

export default function CrochetProjects() {

    return (
        <div className="coming-soon-container">
        <div className="coming-soon-banner">
            <h1>🚧 Crochet projects are coming soon! 🚧</h1>
            <p>Check back later for updates on this section!</p>
        </div>
        </div>
    );
  
}